/* ============================================================
   vm150-cart-packs.js — Velomorph
   ------------------------------------------------------------
   LE PROBLEME
   Les packs sont des VARIANTES, pas des remises. Un client qui
   ajoute "1 sillin" puis passe la quantite a 2 dans le tiroir
   paie 2 x 139,90 au lieu du Pack Duo a 237,90. Shopify n'a
   aucune raison de faire le rapprochement : pour lui ce sont
   deux articles identiques, pas un pack.

   CE QUE FAIT CE FICHIER
   A chaque modification du panier, il recompte le nombre total
   de selles toutes lignes confondues, calcule la meilleure
   combinaison de packs, et reecrit le panier dessus.
     2 selles -> Pack Duo
     3 selles -> Pack Trio
     4 selles -> Pack Trio + 1 sillin   (454,80 contre 475,80
                                         pour deux Duo)
     5 selles -> Pack Trio + Pack Duo

   COMMENT
   Il s'intercale sur window.fetch. La reponse rendue a Dawn est
   deja celle du panier normalise, donc le tiroir n'affiche
   jamais le prix plein, pas meme une fraction de seconde.

   SECURITE
   Si le script ne tourne pas, rien ne casse : le panier reste
   celui de Dawn, au plein tarif. L'echec se fait toujours dans
   le sens ou la boutique encaisse plus, jamais moins.

   La config (ids de variantes, nombre de selles, economie
   affichee) vient de snippets/vm150-cart-packs.liquid : aucun
   id n'est code en dur ici, un resync d'app de sourcing qui
   recree les variantes ne casse donc pas le fichier.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.VM150_PACKS;
  if (!CFG || !CFG.tiers || CFG.tiers.length < 2) return;
  if (window.__vm150CartPacks) return;
  window.__vm150CartPacks = true;

  /* Paliers tries du plus grand au plus petit : la combinaison
     se calcule en prenant d'abord les plus gros packs. Avec un
     prix au sillin qui baisse quand le pack grossit, ce choix
     glouton donne toujours le panier le moins cher. */
  var TIERS = CFG.tiers.slice().sort(function (a, b) { return b.units - a.units; });

  var UNITS = {};
  var SAVE = {};
  TIERS.forEach(function (t) {
    UNITS[String(t.id)] = t.units;
    if (t.save) SAVE[String(t.id)] = t.save;
  });

  var R = window.routes || {};
  var URL_ADD = R.cart_add_url || '/cart/add.js';
  var URL_UPDATE = R.cart_update_url || '/cart/update.js';
  var URL_CART = (R.cart_url || '/cart') + '.js';

  var nativeFetch = window.fetch.bind(window);
  var working = false;

  /* ---- Outils ------------------------------------------------ */

  function isCartMutation(url) {
    return /\/cart\/(add|change|update)(\.js)?($|\?)/.test(String(url).split('#')[0]);
  }

  function post(url, payload) {
    return nativeFetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  /* Les sections a re-rendre sont celles que l'appelant avait
     demandees : tiroir sur une fiche produit, main-cart-items et
     main-cart-footer sur la page panier. On les relit dans la
     requete d'origine au lieu de les deviner. */
  function readMeta(init) {
    var meta = { sections: '', sections_url: window.location.pathname };
    var body = init && init.body;
    try {
      if (body && typeof FormData !== 'undefined' && body instanceof FormData) {
        if (body.get('sections')) meta.sections = String(body.get('sections'));
        if (body.get('sections_url')) meta.sections_url = String(body.get('sections_url'));
      } else if (typeof body === 'string') {
        var o = JSON.parse(body);
        if (o.sections) {
          meta.sections = Object.prototype.toString.call(o.sections) === '[object Array]'
            ? o.sections.join(',')
            : String(o.sections);
        }
        if (o.sections_url) meta.sections_url = String(o.sections_url);
      }
    } catch (e) { /* corps non lisible : on retombe sur le defaut */ }
    if (!meta.sections) meta.sections = 'cart-drawer,cart-icon-bubble';
    return meta;
  }

  function census(cart) {
    var out = { units: 0, found: false, have: {} };
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var key = String(items[i].variant_id);
      var u = UNITS[key];
      if (!u) continue;
      out.found = true;
      out.units += u * items[i].quantity;
      out.have[key] = (out.have[key] || 0) + items[i].quantity;
    }
    return out;
  }

  function best(units) {
    var want = {};
    var rest = units;
    TIERS.forEach(function (t) {
      var n = Math.floor(rest / t.units);
      if (n > 0) {
        want[String(t.id)] = n;
        rest -= n * t.units;
      }
    });
    return want;
  }

  function identical(a, b) {
    var seen = {};
    var k;
    for (k in a) if (a.hasOwnProperty(k)) seen[k] = 1;
    for (k in b) if (b.hasOwnProperty(k)) seen[k] = 1;
    for (k in seen) {
      if ((a[k] || 0) !== (b[k] || 0)) return false;
    }
    return true;
  }

  /* Dawn compare la quantite saisie avec celle de la ligne de
     meme rang dans la reponse. Apres normalisation les rangs ont
     bouge, il affiche donc parfois un message de quantite qui
     n'a plus de sens. On l'efface une fois le rendu termine. */
  function clearNoise() {
    var nodes = document.querySelectorAll('.cart-item__error-text');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = '';
  }

  /* ---- Interception ------------------------------------------ */

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var call = nativeFetch(input, init);
    if (working || !isCartMutation(url)) return call;

    return call.then(function (res) {
      if (!res || !res.ok) return res;

      return res.clone().json().then(function (data) {
        /* change.js et update.js renvoient le panier complet,
           add.js renvoie la ligne ajoutee : dans ce cas il faut
           aller chercher le panier. */
        var cartReady = (data && data.items && typeof data.item_count === 'number')
          ? Promise.resolve(data)
          : nativeFetch(URL_CART, { headers: { 'Accept': 'application/json' } })
              .then(function (r) { return r.json(); });

        return cartReady.then(function (cart) {
          var now = census(cart);
          if (!now.found) return res;

          var want = best(now.units);
          if (identical(now.have, want)) return res;

          var meta = readMeta(init);
          working = true;

          /* update.js ne sait que modifier des lignes existantes.
             Les packs absents du panier passent donc par add.js,
             puis update.js fixe les quantites absolues et rend
             les sections. */
          var adds = [];
          TIERS.forEach(function (t) {
            var delta = (want[String(t.id)] || 0) - (now.have[String(t.id)] || 0);
            if (delta > 0) adds.push({ id: t.id, quantity: delta });
          });

          var step = adds.length ? post(URL_ADD, { items: adds }) : Promise.resolve(null);

          return step.then(function () {
            var updates = {};
            TIERS.forEach(function (t) {
              updates[String(t.id)] = want[String(t.id)] || 0;
            });
            return post(URL_UPDATE, {
              updates: updates,
              sections: meta.sections,
              sections_url: meta.sections_url
            });
          }).then(function (r2) {
            return r2.text();
          }).then(function (txt) {
            working = false;
            [0, 80, 250, 600].forEach(function (d) { setTimeout(clearNoise, d); });
            return new Response(txt, {
              status: 200,
              statusText: 'OK',
              headers: { 'Content-Type': 'application/json' }
            });
          })['catch'](function () {
            working = false;
            return res;
          });
        });
      })['catch'](function () { return res; });
    });
  };

  /* ---- Mention de l'economie sur la ligne de panier ---------- */

  function injectStyles() {
    if (document.getElementById('vm150-cart-packs-styles')) return;
    var s = document.createElement('style');
    s.id = 'vm150-cart-packs-styles';
    s.textContent = '.vm150-cart-save{margin:4px 0 0;font-size:12.5px;line-height:1.3;' +
      'font-weight:700;color:#0b6945;}';
    document.head.appendChild(s);
  }

  function variantIdOf(row) {
    var q = row.querySelector('[data-quantity-variant-id]');
    if (q) return q.getAttribute('data-quantity-variant-id');
    var a = row.querySelector('a[href*="variant="]');
    if (a) {
      var m = a.getAttribute('href').match(/variant=(\d+)/);
      if (m) return m[1];
    }
    return null;
  }

  var painting = false;
  function decorate() {
    if (painting) return;
    painting = true;
    try {
      var rows = document.querySelectorAll('.cart-item');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var tag = row.querySelector('[data-vm150-save]');
        var id = variantIdOf(row);
        var save = id ? SAVE[String(id)] : null;

        if (!save) {
          if (tag && tag.parentNode) tag.parentNode.removeChild(tag);
          continue;
        }
        var text = 'Ahorras ' + save;
        if (tag) {
          if (tag.textContent !== text) tag.textContent = text;
          continue;
        }
        var host = row.querySelector('.cart-item__details') || row;
        var el = document.createElement('p');
        el.className = 'vm150-cart-save';
        el.setAttribute('data-vm150-save', '');
        el.textContent = text;
        var name = host.querySelector('.cart-item__name');
        if (name && name.parentNode === host) name.insertAdjacentElement('afterend', el);
        else host.appendChild(el);
      }
    } finally {
      painting = false;
    }
  }

  var queued = false;
  function queueDecorate() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; decorate(); }, 40);
  }

  function init() {
    injectStyles();
    decorate();
    if (window.MutationObserver) {
      new MutationObserver(queueDecorate).observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
